<div class="rte-container" [class.rte-disabled]="disabled">
  <div class="rte-toolbar" role="toolbar" aria-label="Editor Werkzeugleiste" (mousedown)="$event.preventDefault()">
    <!-- Text Styles -->
    <button
      type="button"
      class="rte-btn"
      [class.active]="isBold"
      [disabled]="disabled"
      (click)="executeCommand('bold')"
      title="Fett (Strg+B)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"></path>
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.active]="isItalic"
      [disabled]="disabled"
      (click)="executeCommand('italic')"
      title="Kursiv (Strg+I)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"></path>
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.active]="isUnderline"
      [disabled]="disabled"
      (click)="executeCommand('underline')"
      title="Unterstrichen (Strg+U)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"></path>
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.active]="isStrike"
      [disabled]="disabled"
      (click)="executeCommand('strikeThrough')"
      title="Durchgestrichen"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M6.85,7.08C6.85,4.37,9.45,3,12.24,3c1.64,0,3,0.49,3.9,1.28c0.77,0.65,1.46,1.73,1.46,3.24h-3.01 c0-0.31-0.05-0.59-0.15-0.85c-0.29-0.86-1.2-1.28-2.25-1.28c-1.86,0-2.34,1.02-2.34,1.7c0,0.48,0.25,0.88,0.74,1.21 C10.97,8.55,11.36,8.78,12,9H7.39C7.18,8.66,6.85,8.11,6.85,7.08z M21,12v-2H3v2h9.62c1.15,0.45,1.96,0.75,1.96,1.97 c0,1-0.81,1.67-2.28,1.67c-1.54,0-2.93-0.54-2.93-2.51H6.4c0,0.55,0.08,1.13,0.24,1.58c0.81,2.29,3.29,3.3,5.67,3.3 c2.27,0,5.3-0.89,5.3-4.05c0-0.3-0.01-1.16-0.48-1.94H21V12z"></path>
      </svg>
    </button>

    <span class="rte-separator"></span>

    <!-- Lists -->
    <button
      type="button"
      class="rte-btn"
      [class.active]="isOrderedList"
      [disabled]="disabled"
      (click)="executeCommand('insertOrderedList')"
      title="Nummerierte Liste"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"></path>
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.active]="isBulletList"
      [disabled]="disabled"
      (click)="executeCommand('insertUnorderedList')"
      title="Aufzählung"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"></path>
      </svg>
    </button>

    <span class="rte-separator"></span>

    <!-- Text Color & Background Color Pickers -->
    <div class="rte-color-wrapper">
      <button
        type="button"
        class="rte-btn"
        [class.active]="showTextColorPicker"
        [disabled]="disabled"
        (click)="toggleTextColorPicker($event)"
        title="Textfarbe"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M2,20h20v4H2V20z M5.49,17h2.42l1.27-3.58h5.65L16.09,17h2.42L13.25,3h-2.5L5.49,17z M9.91,11.39l2.03-5.79h0.12l2.03,5.79 H9.91z"></path>
        </svg>
      </button>
      <div *ngIf="showTextColorPicker" class="rte-popup" (mousedown)="$event.preventDefault()">
        <div class="rte-color-palette">
          <button
            *ngFor="let col of colorPaletteRow1"
            type="button"
            class="rte-color-swatch"
            [style.background-color]="col"
            (click)="applyColor('foreColor', col)"
          ></button>
        </div>
        <div class="rte-color-palette">
          <button
            *ngFor="let col of colorPaletteRow2"
            type="button"
            class="rte-color-swatch"
            [style.background-color]="col"
            (click)="applyColor('foreColor', col)"
          ></button>
        </div>
        <button type="button" class="rte-popup-clear" (click)="applyColor('foreColor', '#000000')">Zurücksetzen</button>
      </div>
    </div>

    <div class="rte-color-wrapper">
      <button
        type="button"
        class="rte-btn"
        [class.active]="showBgColorPicker"
        [disabled]="disabled"
        (click)="toggleBgColorPicker($event)"
        title="Hintergrundfarbe"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M16.56,8.94L7.62,0L6.21,1.41l2.38,2.38L3.44,8.94c-0.59,0.59-0.59,1.54,0,2.12l5.5,5.5C9.23,16.85,9.62,17,10,17 s0.77-0.15,1.06-0.44l5.5-5.5C17.15,10.48,17.15,9.53,16.56,8.94z M5.21,10L10,5.21L14.79,10H5.21z M19,11.5c0,0-2,2.17-2,3.5 c0,1.1,0.9,2,2,2s2-0.9,2-2C21,13.67,19,11.5,19,11.5z M2,20h20v4H2V20z"></path>
        </svg>
      </button>
      <div *ngIf="showBgColorPicker" class="rte-popup" (mousedown)="$event.preventDefault()">
        <div class="rte-color-palette">
          <button
            *ngFor="let col of colorPaletteRow1"
            type="button"
            class="rte-color-swatch"
            [style.background-color]="col"
            (click)="applyColor('hiliteColor', col)"
          ></button>
        </div>
        <div class="rte-color-palette">
          <button
            *ngFor="let col of colorPaletteRow2"
            type="button"
            class="rte-color-swatch"
            [style.background-color]="col"
            (click)="applyColor('hiliteColor', col)"
          ></button>
        </div>
        <button type="button" class="rte-popup-clear" (click)="applyColor('hiliteColor', 'transparent')">Zurücksetzen</button>
      </div>
    </div>

    <span class="rte-separator"></span>

    <!-- Text Alignment -->
    <button
      type="button"
      class="rte-btn"
      [class.active]="isAlignLeft"
      [disabled]="disabled"
      (click)="executeCommand('justifyLeft')"
      title="Linksbündig"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"></path>
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.active]="isAlignCenter"
      [disabled]="disabled"
      (click)="executeCommand('justifyCenter')"
      title="Zentriert"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"></path>
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.active]="isAlignRight"
      [disabled]="disabled"
      (click)="executeCommand('justifyRight')"
      title="Rechtsbündig"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"></path>
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.active]="isAlignJustify"
      [disabled]="disabled"
      (click)="executeCommand('justifyFull')"
      title="Blocksatz"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"></path>
      </svg>
    </button>

    <span class="rte-separator"></span>

    <!-- Remove Formatting -->
    <button
      type="button"
      class="rte-btn"
      [disabled]="disabled"
      (click)="executeCommand('removeFormat')"
      title="Formatierung entfernen"
    >
      <i class="ri-format-clear"></i>
    </button>
  </div>

  <div
    #editorArea
    class="rte-content"
    contenteditable="true"
    [attr.data-placeholder]="placeholder"
    [style.min-height]="minHeight"
    (input)="onInput()"
    (blur)="onBlur()"
    (keydown)="onKeydown($event)"
    (keyup)="updateToolbarState()"
    (mouseup)="updateToolbarState()"
    (paste)="onPaste($event)"
  ></div>
</div>
